import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';

import { CustomInputProps } from './props';

const CustomInput: React.FC<CustomInputProps> = ({
  outlinedInputProps,
  showRequired = true,
  ...props
}: CustomInputProps) => {
  // ================ VIEWS
  return (
    <FormControl fullWidth {...props}>
      <Box sx={{ display: 'flex' }}>
        <InputLabel sx={{ display: 'flex' }}>
          {outlinedInputProps?.label}
          {outlinedInputProps?.required && showRequired && (
            <Typography sx={{ ml: 1 }}>*</Typography>
          )}
        </InputLabel>
        <OutlinedInput {...outlinedInputProps} />
      </Box>
    </FormControl>
  );
};

export default CustomInput;
